import { http } from '../http';

export interface Regional {
  id: string;
  codigo_regional: string;
  nome: string;
  nome_fantasia: string;
  cnpj: string;
}

export interface RegionalResponse {
  total: number;
  page: number;
  limit: number;
  items: Regional[];
}

export const fetchSgaRegionais = async (
  page: number = 1,
  limit: number = 10,
  busca?: string
): Promise<RegionalResponse> => {
  const termo = busca && busca.trim() ? busca.trim() : undefined;
  const response = await http.get('/sga-regional/listar', {
    params: { page, limit, ...(termo ? { busca: termo } : {}) },
  });

  return response.data;
};

/** Sincroniza o espelho de regionais com o SGA (TI/ADMIN, at-34). */
export const sincronizarSgaRegionais = async (): Promise<{
  sincronizadas: number;
  inativadas: number;
}> => {
  const { data } = await http.get('/sga-regional/sync');
  return data;
};
